import { instance as axios } from "../axios";
import JWT from "jsonwebtoken";

import { PRIVATE, PUBLIC } from "../variables";

const TABLE = "/aviso/";

// initial state
const state = {
  data: [],
  all: false
};

// getters
const getters = {
  getAll: state => {
    return state.data;
  },
  getState: state => {
    return state.all;
  }
};

// actions
const actions = {
  get({ commit }, params = false) {
    var t = params ? TABLE + "todos/" : TABLE;
    return axios
      .get(t)
      .then(res => {
        decode(res.data.data).then(r => {
          if (r) {
            commit("setData", r);
            commit("setAll", params);
          } else commit("setData", null);
        });
      })
      .catch(err => {
        commit("setData", null);
      });
  },

  getByEscritorio({ commit, rootState }, params = false) {
    var t = params
      ? TABLE + "todos/" + rootState.session.user.id_escritorio
      : TABLE + "user/" + rootState.session.user.id_escritorio;
    return axios
      .get(t)
      .then(res => {
        return decode(res.data.data).then(r => {
          if (r) {
            commit("setData", r);
            commit("setAll", params);
          } else commit("setData", null);
        });
      })
      .catch(err => {
        commit("setData", null);
      });
  },

  insert({ dispatch }, params) {
    return axios
      .post(TABLE, {
        t: token(params)
      })
      .then(res => {
        if (!res.data.errors) {
          dispatch("get");
          return true;
        } else return false;
      })
      .catch(err => {
        return false;
      });
  },

  update({ dispatch }, params) {
    return axios
      .post(TABLE + "update/", {
        t: token(params)
      })
      .then(res => {
        if (!res.data.errors) {
          dispatch("get");
          return true;
        } else return false;
      })
      .catch(err => {
        return false;
      });
  },

  setChecked({ dispatch }, params) {
    return axios
      .put(TABLE + "checked/" + token(params))
      .then(res => {
        return !res.data.errors;
      })
      .catch(err => {
        return false;
      });
  },

  delete({ dispatch }, params) {
    return axios
      .delete(TABLE + token(params))
      .then(res => {
        if (!res.data.errors) {
          dispatch("get");
          return true;
        } else return false;
      })
      .catch(err => {
        return false;
      });
  }
};

// mutations
const mutations = {
  setData(state, data) {
    state.data = data ? [].concat(data) : [];
  },

  setAll(state, data) {
    state.all = data;
  }
};

function token(params) {
  return JWT.sign(
    {
      exp: Math.floor(Date.now() / 1000) + 60,
      data: params
    },
    PRIVATE,
    { algorithm: "RS256" }
  );
}

function decode(token) {
  return new Promise(function(resolve, reject) {
    JWT.verify(token, PUBLIC, (err, decoded) => {
      if (err) resolve(false);
      else resolve(JWT.decode(token).data);
    });
  });
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/avisos.js